<template>
  <div class="navbar">
    <div style="padding-top: 7px">
      <logo :collapse="isCollapse" />
      <hamburger
        v-if="appStore.sidebar.opened"
        id="hamburger-container"
        :is-active="appStore.sidebar.opened"
        class="hamburger-container"
        @toggle-click="toggleSideBar"
      />
    </div>
    <div class="muneBox">
      <top-nav id="topmenu-container" />
    </div>
    <!-- <breadcrumb v-if="!settingsStore.topNav" id="breadcrumb-container" class="breadcrumb-container" /> -->
    <div class="right-menu flex align-center">
      <template v-if="appStore.device !== 'mobile'">
        <!-- <el-select v-if="userId === 1 && tenantEnabled" v-model="companyName" class="min-w-244px" clearable filterable
          reserve-keyword :placeholder="proxy.$t('navbar.selectTenant')" @change="dynamicTenantEvent"
          @clear="dynamicClearEvent">
          <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.companyName" :value="item.tenantId">
          </el-option>
          <template #prefix><svg-icon icon-class="company" class="el-input__icon input-icon" /></template>
</el-select> -->

        <search-menu ref="searchMenuRef" />
        <!-- <el-tooltip content="搜索" effect="dark" placement="bottom">
          <div class="right-menu-item hover-effect" @click="openSearchMenu">
            <svg-icon class-name="search-icon" icon-class="search" />
          </div>
        </el-tooltip> -->
        <!-- 消息 -->
        <!-- <el-tooltip :content="proxy.$t('navbar.message')" effect="dark" placement="bottom">
          <div>
            <el-popover v-if="false" placement="bottom" trigger="click" transition="el-zoom-in-top" :width="300" :persistent="false">
              <template #reference>
                <el-badge :value="newNotice > 0 ? newNotice : ''" :max="99">
                  <div class="right-menu-item hover-effect" style="display: block"><svg-icon icon-class="message" />
                  </div>
                </el-badge>
              </template>
              <template #default>
                <notice></notice>
              </template>
            </el-popover>
          </div>
        </el-tooltip> -->
        <!-- 信息 -->
        <el-popover
          v-if="false"
          placement="bottom"
          trigger="click"
          transition="el-zoom-in-top"
          :width="300"
          :persistent="false"
        >
          <template #reference>
            <div class="infoItem">
              <div>
                <el-badge
                  :value="newNotice > 0 ? newNotice : ''"
                  :max="99"
                >
                  <div class="effect_icon">
                    <svg
                      t="1765244268434"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6657"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M825.11398 676.695821l-39.805636-0.199028 0.511787-91.439234c0.710815-131.415466 0.76768-142.162988 0.76768-179.125364a274.602027 274.602027 0 1 0-549.204054 0c0 37.502596 0.341191 267.266417 0.341191 269.569457h-39.805637c0-2.30304-0.341191-232.095294-0.341191-269.626322a314.407663 314.407663 0 1 1 628.815327 0c0 36.962377 0 47.709899-0.76768 179.125364z"
                        p-id="6658"
                      />
                      <path
                        d="M859.943912 891.276635H164.056088a54.448424 54.448424 0 0 1-47.055949-81.857449l80.805442-138.665778v-23.627488l39.805637 0.142163v34.318145l-86.150771 147.849507a14.642788 14.642788 0 0 0 12.652506 22.006831h695.830959a14.642788 14.642788 0 0 0 12.652506-22.006831l-86.008607-147.593614-1.137304-32.924948 39.805636-1.393197 0.796113 22.916674 80.947605 138.950104a54.419992 54.419992 0 0 1-47.027516 81.857448z"
                        p-id="6659"
                      />
                      <path
                        d="M511.985784 1024a152.796779 152.796779 0 0 1-152.597751-152.626184h39.805636a112.820547 112.820547 0 1 0 225.612662 0h39.805636a152.796779 152.796779 0 0 1-152.626183 152.626184zM450.713536 134.571484a13.363321 13.363321 0 0 1-19.902818-4.918839 87.913592 87.913592 0 0 1-6.397335-17.656643 91.410801 91.410801 0 0 1-2.644231-21.722505 90.273497 90.273497 0 1 1 177.902762 21.836235 93.827572 93.827572 0 0 1-2.843259 9.496488c-0.483354 1.307899-1.023574 2.644232-1.563793 3.952131a13.363321 13.363321 0 0 1-19.504762 5.686519L564.443926 124.108288a13.505484 13.505484 0 0 1-5.1463-16.235013 49.302124 49.302124 0 0 0 1.620658-5.288463 50.467861 50.467861 0 1 0-99.514091-12.226017 51.178676 51.178676 0 0 0 1.478495 12.169152 49.870776 49.870776 0 0 0 2.84326 8.273886 13.24959 13.24959 0 0 1-4.463918 16.064417z"
                        p-id="6660"
                      />
                    </svg>
                  </div>
                </el-badge>
              </div>
              <div>{{ proxy.$t('navbar.message') }}</div>
            </div>
          </template>
          <template #default>
            <notice />
          </template>
        </el-popover>

        <getDownloadList v-if="false" />
        <lang-select>
          <template #language>
            <div class="infoItem">
              <div>
                <div class="effect_icon">
                  <svg
                    t="1765245284310"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="22441"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M549.12 643.008L440.768 535.936l1.28-1.28A747.52 747.52 0 0 0 600.32 256h125.056V170.688H426.688V85.376H341.376v85.312H42.688v84.928h476.608A670.4 670.4 0 0 1 384 484.288a667.52 667.52 0 0 1-98.56-142.912H200.128a749.312 749.312 0 0 0 127.168 194.56L110.08 750.08l60.608 60.544L384 597.376l132.736 132.672 32.384-87.04z m240.256-216.32H704l-192 512h85.376l47.744-128h202.688l48.192 128h85.376l-192-512z m-111.808 298.688l69.12-184.768 69.12 184.768h-138.24z"
                      p-id="22442"
                    />
                  </svg>
                </div>
              </div>
              <div>{{ proxy.$t('navbar.language') }}</div>
            </div>
          </template>
        </lang-select>

        <!--  <el-tooltip content="Github" effect="dark" placement="bottom">
          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />
        </el-tooltip>

        <el-tooltip :content="proxy.$t('navbar.document')" effect="dark" placement="bottom">
          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!--
        <el-tooltip :content="proxy.$t('navbar.full')" effect="dark" placement="bottom">
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!-- <el-tooltip :content="proxy.$t('navbar.language')" effect="dark" placement="bottom">
          <lang-select id="lang-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <!-- <el-tooltip :content="proxy.$t('navbar.layoutSize')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>
      <div class="avatar-container">
        <el-dropdown
          class="right-menu-item hover-effect"
          trigger="click"
          @command="handleCommand"
        >
          <div class="avatar-wrapper">
            <!-- 头像 -->

            <!-- <img :src="userStore.avatar" class="user-avatar" /> -->
            <AvatarColor
              key-type="logo"
              :name="userStore.nickname"
            />

            <span class="user-name">{{ userStore.nickname }}</span>

            <el-icon><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <div class="userBOX">
              <el-dropdown-menu>
                <router-link
                  v-if="false"
                  to="/user/profile"
                >
                  <el-dropdown-item>
                    <div class="flex">
                      <span> {{ proxy.$t('navbar.personalCenter') }}</span>
                      <svg
                        t="1764324375587"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8294"
                        width="18"
                        height="18"
                      >
                        <path
                          d="M512.00614 526.971963c95.167286 0 172.580245-77.386353 172.580245-172.551593V267.512172c0-79.322445-64.550026-143.815166-143.816189-143.815166h-57.542439c-79.293792 0-143.815166 64.492721-143.815166 143.815166v86.908198c0.001023 95.166263 77.415006 172.551593 172.593549 172.551593zM396.939681 267.512172c0-47.58262 38.707503-86.317752 86.288076-86.317752h57.542439c47.57955 0 86.289099 38.736155 86.2891 86.317752v86.908198c0 63.424391-51.628764 115.052133-115.054179 115.052133-63.468393 0-115.066459-51.627741-115.066459-115.052133V267.512172z"
                          p-id="8295"
                        />
                        <path
                          d="M660.483479 528.235744c-36.289435-6.068194-71.345789 12.247927-87.804613 44.493264-9.943446 19.492921-28.53893 42.693273-60.672726 42.693273-32.148123 0-50.742583-23.200352-60.68603-42.693273-16.459847-32.24636-51.458896-50.561458-87.834288-44.493264-152.044578 25.169189-254.177495 140.474078-254.177496 286.959044v21.233561l20.279842 6.263644C253.601375 880.893984 382.248103 900.302994 512.005117 900.302994c129.716081 0 258.362809-19.40901 382.403645-57.611001l20.279842-6.263644v-21.233561c0.002047-146.484966-102.130871-261.790878-254.205125-286.959044zM167.705224 794.014438c9.017356-108.535732 87.526274-189.545605 205.16225-209.039549 11.434401-1.713011 21.993876 3.651149 27.219891 13.932286 24.013879 47.076084 64.830411 74.041172 111.919798 74.041172 47.076084 0 87.861918-26.966111 111.907519-74.041172 5.223968-10.281137 15.955358-15.589015 27.189191-13.932286 117.638022 19.494967 196.174569 100.503817 205.16225 209.039549-223.927601 64.715801-464.635344 64.715801-688.560899 0z"
                          p-id="8296"
                        />
                      </svg>
                    </div>
                  </el-dropdown-item>
                </router-link>

                <el-dropdown-item>
                  <div
                    class="flex"
                    @click="setShop"
                  >
                    <span>{{ proxy.$t('navbar.SwitchStores') }}</span>
                    <svg
                      t="1764324203626"
                      class="icon"
                      viewBox="0 0 1088 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5742"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M710.390827 769.590062V775.461061c0 1.957 0 1.957-1.957 3.913999v1.956999l-46.967988 101.763975c-5.870999 11.741997-15.655996 17.612996-27.397994 17.612996-3.913999 0-7.827998 0-11.741997-1.956999-15.655996-5.870999-21.526995-23.483994-13.698997-39.139991l7.827998-15.655996c-23.483994 7.827998-46.967989 11.741997-70.451982 11.741997-58.709986 0-115.462972-23.483994-158.516962-64.580984-41.09699-41.09699-64.580984-99.806976-64.580984-158.516961 0-15.655996 13.698997-29.354993 29.354993-29.354993s29.354993 13.698997 29.354993 29.354993c0 43.053989 17.612996 86.107979 48.924988 115.462971 31.311992 31.311992 72.408982 48.924988 115.462972 48.924988 21.526995 0 43.053989-3.913999 62.623984-13.698996l-25.440993-5.870999c-15.655996-3.913999-25.440994-19.569995-23.483995-35.225991 3.913999-15.655996 19.569995-25.440994 35.225992-23.483994l93.935977 19.569995H694.73483s1.957 0 1.957 1.956999l1.956999 1.957 1.957 1.956999 1.956999 1.957 1.957 1.956999 1.957 1.957s0 1.957 1.956999 1.956999c0 0 0 1.957 1.957 1.957v15.655996z m-166.34496-360.087912c-27.397993 0-54.795987 5.870999-80.23698 15.655996l7.827998-21.526995c5.870999-15.655996-1.957-31.311992-17.612996-37.18299-15.655996-5.870999-31.311992 1.957-37.182991 17.612995l-37.182991 101.763975v15.655997c0 1.957 0 1.957 1.957 3.913999v1.956999s0 1.957 1.956999 1.957c0 0 0 1.957 1.957 1.956999l1.956999 1.957 1.957 1.956999s1.957 0 1.956999 1.957c1.957 0 1.957 1.957 3.913999 1.956999s1.957 1.957 3.914 1.957 3.913999 1.957 5.870998 1.956999l99.806976 15.655996h3.913999c13.698997 0 27.397993-9.784998 29.354993-25.440993 1.957-15.655996-7.827998-31.311992-23.483995-33.268992l-23.483994-3.913999c17.612996-5.870999 37.182991-9.784998 56.752986-9.784998 43.053989 0 86.107979 17.612996 115.462972 48.924988 31.311992 31.311992 48.924988 72.408982 48.924988 115.462972 0 15.655996 13.698997 29.354993 29.354993 29.354993s29.354993-13.698997 29.354993-29.354993c0-58.709986-23.483994-115.462972-64.580984-158.516961-46.967989-39.13999-103.720975-62.623985-162.430961-62.623985z m540.131868 58.709986c-9.784998 29.354993-37.182991 46.967989-68.494983 46.967988h-88.064978c-5.870999 0-9.784998 3.913999-9.784998 9.784998v410.9699c0 48.924988-43.053989 88.064978-93.935977 88.064978H254.409938c-50.881988 0-93.935977-39.13999-93.935977-88.064978v-410.9699c0-5.870999-3.913999-9.784998-9.784998-9.784998H74.365982c-33.268992 0-60.666985-19.569995-70.451983-48.924988-9.784998-27.397993 0-56.752986 23.483994-74.365982L497.077879 16.145246c27.397993-21.526995 68.494983-21.526995 97.849976 0L1060.693741 391.889154c25.440994 19.569995 33.268992 48.924988 23.483994 76.322982z m-58.709985-29.354993L557.744864 63.113235c-3.913999-3.913999-7.827998-3.913999-11.741997-3.913999-3.913999 0-9.784998 1.957-11.741997 3.913999l-469.679886 375.743908c-5.870999 1.957-5.870999 5.870999-5.870998 7.827998 1.957 3.913999 5.870999 9.784998 15.655996 9.784998h76.322981c37.182991 0 68.494983 31.311992 68.494983 68.494983v410.9699c0 15.655996 15.655996 29.354993 35.225992 29.354992h569.486861c19.569995 0 35.225991-13.698997 35.225991-29.354992v-410.9699c0-37.182991 31.311992-68.494983 68.494984-68.494983h88.064978c7.827998 0 11.741997-3.913999 13.698997-7.827999 0-1.957 1.957-5.870999-3.913999-9.784997z"
                        p-id="5743"
                      />
                    </svg>
                  </div>
                </el-dropdown-item>
                <router-link
                  v-if="!dynamic"
                  to="/getNotice"
                >
                  <el-dropdown-item>
                    <div class="flex">
                      <div>
                        <span
                          v-if="activeVersion != version"
                          class="activeVersion"
                        />{{ proxy.$t('navbar.version') }}:{{ version }}
                      </div>
                      <svg
                        t="1764324278128"
                        class="icon"
                        viewBox="0 0 1028 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="7638"
                        width="16"
                        height="16"
                      >
                        <path
                          d="M512 1024C230.4 1024 0 793.6 0 512v-42.666667c0-12.8 4.266667-29.866667 4.266667-42.666666 42.666667-247.466667 256-426.666667 503.466666-426.666667 68.266667 0 136.533333 12.8 200.533334 42.666667 21.333333 8.533333 29.866667 34.133333 21.333333 55.466666-4.266667 21.333333-25.6 29.866667-51.2 21.333334-51.2-21.333333-106.666667-34.133333-166.4-34.133334-209.066667 0-384 149.333333-422.4 354.133334l-4.266667 38.4v34.133333c0 234.666667 192 426.666667 426.666667 426.666667h38.4c12.8 0 21.333333-4.266667 34.133333-4.266667 204.8-34.133333 354.133333-213.333333 354.133334-422.4 0-51.2-8.533333-217.6-123.733334-217.6-72.533333 0-106.666667 68.266667-149.333333 166.4-8.533333 21.333333-17.066667 38.4-25.6 59.733333l-93.866667 187.733334c-8.533333 12.8-21.333333 25.6-38.4 25.6s-29.866667-8.533333-38.4-25.6L298.666667 354.133333c-8.533333-21.333333 0-46.933333 21.333333-55.466666 21.333333-8.533333 46.933333 0 55.466667 21.333333L512 597.333333l55.466667-110.933333c8.533333-17.066667 17.066667-34.133333 25.6-55.466667 38.4-93.866667 93.866667-217.6 226.133333-217.6 128 0 209.066667 115.2 209.066667 302.933334 0 251.733333-179.2 460.8-426.666667 503.466666-12.8 4.266667-25.6 4.266667-38.4 4.266667H512z"
                          p-id="7639"
                        />
                      </svg>
                    </div>
                  </el-dropdown-item>
                </router-link>
                <el-dropdown-item
                  divided
                  command="logout"
                >
                  <div class="flex">
                    <span>{{ proxy.$t('navbar.logout') }}</span>
                    <svg
                      t="1764324337037"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6428"
                      width="20"
                      height="20"
                    >
                      <path
                        d="M482.464 512V157.536a29.536 29.536 0 0 1 59.072 0V512a29.504 29.504 0 1 1-59.072 0z m344.064-220.256a383.04 383.04 0 0 0-94.208-94.368l-0.096 0.096a29.472 29.472 0 1 0-33.824 48.384c0.128 0.096 0.288 0.096 0.416 0.192 40 28.128 50.976 39.104 79.328 79.584 102.752 146.752 66.976 349.792-79.808 452.544a325.824 325.824 0 0 1-372.736 0.064 323.84 323.84 0 0 1-79.712-79.904c-49.792-71.008-68.896-157.28-53.824-242.72s62.528-159.968 133.664-209.728c0.224-0.16 0.48-0.288 0.672-0.48l-0.16-0.16A29.504 29.504 0 0 0 291.776 197.44c-0.096 0.064-0.128 0.224-0.256 0.256l-0.032-0.032C118.016 319.36 75.904 558.656 197.472 732.256a383.04 383.04 0 0 0 94.208 94.368c128.448 89.952 304.64 95.072 440.544-0.064 173.728-121.664 215.936-361.12 94.304-534.816z"
                        p-id="6429"
                      />
                    </svg>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </template>
        </el-dropdown>
      </div>
    </div>
    <switchShop ref="switchShopRef" />
  </div>
</template>

<script setup lang="ts">
import Logo from './Logo.vue';
import SearchMenu from './TopBar/search.vue';
import getDownloadList from './getDownloadList.vue';
import switchShop from './switchShop/index.vue';
import { useAppStore } from '@/store/modules/app';
import { useUserStore } from '@/store/modules/user';
import { useNoticeStore } from '@/store/modules/notice';
import notice from './notice/index.vue';
import router from '@/router';
import { getSafeRedirectPath } from '@/utils';
import { version } from '../../../package.json';
import { ElMessageBoxOptions } from 'element-plus/es/components/message-box/src/message-box.type';
import AvatarColor from '@/components/AvatarColor/index.vue';

const appStore = useAppStore();
const userStore = useUserStore();
const noticeStore = storeToRefs(useNoticeStore());
const newNotice = ref(0 as number);
const activeVersion = ref(null);

const { proxy } = getCurrentInstance() as ComponentInternalInstance;
// 是否切换了租户
const dynamic = ref(false);
const switchShopRef = ref(null);
// 搜索菜单
const searchMenuRef = ref<InstanceType<typeof SearchMenu>>();
const isCollapse = computed(() => !appStore.sidebar.opened);
onMounted(() => {
  activeVersion.value = localStorage.getItem('version');
});

// 切换门店
const setShop = () => {
  switchShopRef.value.dialogVisibleFn();
};

/** 租户列表 */
const initTenantList = async () => {
  // const { data } = await getTenantList(true);
  // tenantEnabled.value = data.tenantEnabled === undefined ? true : data.tenantEnabled;
  // if (tenantEnabled.value) {
  //   tenantList.value = data.voList;
  // }
};

defineExpose({
  initTenantList,
});

const toggleSideBar = () => {
  appStore.toggleSideBar(false);
};

const logout = async () => {
  const options: ElMessageBoxOptions = {
    confirmButtonText: proxy.$t('Shared.Confirm'),
    cancelButtonText: proxy.$t('Shared.Cancel'),
    type: 'warning',
  };
  await ElMessageBox.confirm(proxy.$t('login.logoutTitle'), proxy.$t('Shared.Prompt'), options);
  userStore.logout().then(() => {
    router.replace({
      path: '/login',
      query: {
        redirect: encodeURIComponent(getSafeRedirectPath(router.currentRoute.value.fullPath || '/')),
      },
    });
    proxy?.$tab.closeAllPage();
  });
};

const emits = defineEmits(['setLayout']);
const setLayout = () => {
  emits('setLayout');
};
// 定义Command方法对象 通过key直接调用方法
const commandMap: { [key: string]: any } = {
  setLayout,
  logout,
};
const handleCommand = (command: string) => {
  // 判断是否存在该方法
  if (commandMap[command]) {
    commandMap[command]();
  }
};
// 用深度监听 消息
watch(
  () => noticeStore.state.value.notices,
  (newVal) => {
    newNotice.value = newVal.filter((item: any) => !item.read).length;
  },
  { deep: true },
);
</script>

<style lang="scss" scoped>
.userBOX {
  min-width: 140px;

  .flex {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &:hover {
      .icon {
        fill: var(--color-1) !important;
      }
    }

    .icon {
      fill: #777 !important;
      margin-inline-start: 15px;
    }
  }
}

.infoItem {
  height: 28px;
  line-height: 28px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #666;
  letter-spacing: 1px;
  cursor: pointer;
  border-radius: 14px;
  margin-inline-start: 5px;

  &:hover {
    background: #f0f0f0;
  }

  .effect_icon {
    margin-inline-end: 3px;
    padding-top: 4px;

    .icon {
      fill: #666;
    }
  }
}

:deep(.el-select .el-input__wrapper) {
  height: 30px;
}

:deep(.el-badge__content.is-fixed) {
  top: 12px;
}

.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.navbar {
  padding-inline-start: 10px;
  height: 64px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  .muneBox {
    flex: 1;
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    // float: inset-inline-start;
    display: inline-block;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: inset-inline-start;
  }

  .topmenu-container {
    position: absolute;
    inset-inline-start: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        margin-top: 15px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 30px;
          height: 30px;
          border-radius: 15px;
          margin-top: 15px;
          vertical-align: middle;
        }

        .user-name {
          line-height: 30px;
          font-size: 14px;
          margin: 0px 5px;
          vertical-align: bottom;
          color: #666;
          position: relative;
          top: -3px;
        }

        i {
          cursor: pointer;
          position: relative;
          top: -9px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
